import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/** Goo is shiny blob voxels; every colour flows in the one sim and fuses into one surface. */
export const OOZERY_LIQUID = liquidKind('blob', { material: 'shiny' })

/** One frame of a pour's goo (poured, fallen, slumped): a press is one undo step (the coalescer accumulates in place). */
export const OOZERY_SETTLE = liquidSettleEvent('experience.oozery.settle', OOZERY_LIQUID)

/** Reducer handlers for Oozery (`experience.oozery.*`). */
export const eventHandlers = OOZERY_SETTLE.handlers
